<section id="home" class="no-padding slider-style1 border-none header-margin-top-medium">
    <owl-carousel [options]="{items: 1, 
        dots: true, 
        navigation: true, 
        loop: true, 
        autoplay: true,  
        autoplayHoverPause: true, 
        slideSpeed: 300,  
        paginationSpeed: 400, 
        singleItem: true,
        navClass: [
        'fa fa-long-arrow-left',
        'fa fa-long-arrow-right']        
    }" [carouselClasses]="['owl-slider-auto', 
    'owl-carousel', 
    'owl-theme',
    'owl-without-next-pre-arrow', 
    'owl-light-pagination']">
        <!-- slider item -->
        <div class="item owl-bg-img cover-background bg-img-one" data-img-size="(W)1920px X (H)994px " style="background:
        linear-gradient(rgba(15, 15, 15, 0.7), rgba(15, 15, 15, 0.4)) repeat scroll 0% 0%, transparent url(
        'assets/images/slide-image/slide-1.jpg') repeat scroll 0% 0%; ">
            <div class="container small-screen xs-one-second-screen position-relative ">
                <div class="col-md-12 col-sm-12 col-xs-12 slider-typography text-left sm-position-inherit ">
                    <div class="slider-text-middle-main ">
                        <div class="slider-text-middle ">
                            <div
                                class="col-md-7 col-sm-10 col-xs-12 no-padding alt-font slider-content sm-no-margin-top display-grid">
                                <div class="title-extra-large-2 line-height-50 font-weight-600 text-white slider-title
        margin-seven-bottom letter-spacing-minus-1 " id=" ">Somos </div>
                                <div class="text-extra-large text-white main-font font-weight-500 slider-text margin-ten-bottom
        width-80 xs-width-100 " id=" "> Gente de campo al servicio del campo.</div>
                                <div class="btn-dual margin-top-boton-conozcanos ">
                                    <a class="btn btn-large btn-circle bg-dark-brown text-white inner-link "
                                        routerLink="/empresa" routerLinkActive="active "><span>CONÓZCANOS MÁS
                                        </span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end slider item -->
        <!-- slider item -->
        <div class="item owl-bg-img cover-background bg-img-one " data-img-size="(W)1920px X (H)994px " style="background:
    linear-gradient(rgba(15, 15, 15, 0.7), rgba(15, 15, 15, 0.4)) repeat scroll 0% 0%, transparent url(
    'assets/images/slide-image/slide-2.jpg') repeat scroll 0% 0%; ">
            <div class="container small-screen xs-one-second-screen position-relative ">
                <div class="col-md-12 col-sm-12 col-xs-12 slider-typography text-left sm-position-inherit ">
                    <div class="slider-text-middle-main ">
                        <div class="slider-text-middle ">
                            <div
                                class="col-md-7 col-sm-10 col-xs-12 no-padding alt-font slider-content sm-no-margin-top ">
                                <div class="title-extra-large-2 line-height-50 font-weight-600 text-white slider-title
    margin-seven-bottom letter-spacing-minus-1 " id=" ">Subastas de ganado las 24 horas del día</div>
                                <div class="text-extra-large text-white main-font font-weight-500 slider-text margin-ten-bottom
    width-80 xs-width-100 " id=" ">Identificá los mejores lotes de ganado desde tu smartphone, pc o tablet.<br>
                                    Comercializá tu ganado en nuestras subastas online. </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end slider item -->
    </owl-carousel>
</section>
<section class="flyer-style3 padding-60px-tb xs-padding-60px-tb bg-white " id=" ">
    <div class="container ">
        <div class="row col-lg-10 col-lg-offset-1 ">
            <owl-carousel [options]="{items: 1, 
                    dots: true, 
                    navigation: true, 
                    loop: false, 
                    autoplay: true, 
                    autoplayHoverPause: true, 
                    slideSpeed: 300,  
                    paginationSpeed: 400, 
                    singleItem: true,
                    navClass: [
                    'fa fa-long-arrow-left',
                    'fa fa-long-arrow-right']        
                }" [items]="imagenesFlyer2" [carouselClasses]="['owl-slider-auto', 
                'owl-carousel', 
                'owl-theme', 
                'black-pagination', 
                'owl-dark-pagination',
                'owl-pagination-bottom', 
                'owl-no-buttons']">
                <!-- item -->
                <div *ngFor="let image of imagenesFlyer2; let i=index">
                    <div class="col-lg-12 col-md-12 col-sm-12 flyer-img cover-background bg-img-seven " id=" ">
                        <img [src]="image.thumb" (click)="openImage(i)" />
                    </div>
                </div>
                <!-- end item -->
            </owl-carousel>
        </div>
    </div>
</section>
<section class="bg-dark-brown border-none " id=" ">
    <div class="container-fluid ">
        <div class="btn-dual text-center margin-five ">
            <a class="btn btn-large btn-circle bg-white text-dark-brown margin-one " routerLink="/subastas"
                routerLinkActive="active "><span>VER LOTES</span></a>
            <a class="btn btn-large btn-circle bg-white text-dark-brown margin-one " 
                href="https://www.youtube.com/channel/UCG7Kmm-YV8g4fi0zJWSn_1A/live"><span>SUBASTA EN VIVO</span></a>
        </div>
    </div>
</section>
<section class="bg-white padding-30px-tb xs-padding-60px-tb border-none " id=" ">
    <div class="container ">
        <div class="row ">
            <div class="col-md-7 col-sm-12 col-xs-12 margin-five-bottom ">
                <!-- title -->
                <h2 class="title alt-font title-extra-large font-weight-500 sm-title-extra-large-2 xs-section-title-large
    text-brown margin-one-bottom text-center ">Información Agropecuaria </h2>
                <!-- end  title -->
                <ul class="links ">
                    <div *ngFor="let info of infoAgropecuaria">
                        <li class="margin-one-half-bottom "><i
                                class="far fa-newspaper icon-extra-small margin-one-half "></i><a
                                class="text-medium text-dark-gray " href="{{info.url}}"
                                target="_blank">{{info.titulo}}</a></li>
                    </div>
                </ul>
            </div>
            <div class="col-md-5 col-sm-12 col-xs-12 margin-five-bottom xs-text-center ">
                <!-- title -->
                <h2 class="title alt-font title-extra-large font-weight-500 sm-title-extra-large-1 xs-section-title-large
    text-brown margin-one-bottom text-center ">Cotizaciones</h2>
                <!-- end  title -->
                <!-- item -->
                <div class=" text-center xs-margin-fifteen-bottom ">
                    <div class="position-relative bg-white ">
                        <div class="col-xs-4 moneda" *ngFor="let moneda of monedas">
                            <div><i [ngClass]="'icono-moneda '+ moneda.isoCode"></i>{{moneda.nombre}}</div>
                            <div class="cotizacion-letra-chica">COMPRA</div>
                            <div class="cotizacion-letra-grande"> {{moneda.purchasePrice}}</div>
                            <div class="cotizacion-letra-chica">VENTA</div>
                            <div class="cotizacion-letra-grande"> {{moneda.salePrice}}</div>
                        </div>
                    </div>
                </div>
                <!-- end item -->
                <div id="c_10323413293fece32340c23d31df235f" class="normal"
                    style="border:1px solid #dcdcdc;width:180px;background:#ffffff;overflow:hidden;">
                    <a class="weatherwidget-io" href="https://forecast7.com/es/n25d26n57d58/asuncion/"
                        data-label_1="Clima en" data-label_2="Asunción" data-icons="Climacons Animated"
                        data-theme="pure" data-days="5">ASUNCIÓN WEATHER</a>
                    <script>
                    </script>
                </div>
            </div>
        </div>
    </div>
    <div class="separator-line1 width-80 bg-dark-brown center-col "></div>
</section>
